<app-header nav="3" />
<mat-tab-group>
  <mat-tab label="Homepage">
    <app-admin-homepage />
  </mat-tab>
  <mat-tab label="Keywords">
    <app-admin-keywords />
  </mat-tab>
  <mat-tab label="Manual Triggers">
    <app-admin-manual-triggers />
  </mat-tab>
</mat-tab-group>
